
const FeatureFlag = {
    ModoSteamHabilitado: true,
    DesabilitaConsumoTotalDePersonagensEContas: true,
    DesabilitaStatusJogo: true,
    DesabilitaNoticiasDoJogo: true,
    HabilitaIFrameDeNoticiasDaSteam: true,
}

export {
    FeatureFlag
}